import { get, post } from '../../common/httpService';

const getReviews = (slug, pageSize = 5, page = 0, sortType = 2) => {
    return get({
        url: `Review/ReviewsJson?productSlug=${slug}&page=${page}&pageSize=${pageSize}&t=${sortType}`,
    });
};

const userVoteYes = (id, slug) => {
    return post({
        url: `Review/UserVoteYes/${id}`,
        body: slug,
    });
};

const userVoteNo = (id, slug) => {
    return post({
        url: `Review/UserVoteNo/${id}`,
        body: slug,
    });
};

const reportAbuse = (id, slug, type) => {
    return post({
        url: `Review/UserReportAbuse/${id}?ProductSlug=${slug}`,
        body: type,
    });
};

export { getReviews, userVoteYes, userVoteNo, reportAbuse };
